import React, { useState } from "react";
import "./App.css";
import { CircleSteps } from "./components/CircleSteps/CircleSteps";
import { Step1Form } from "./components/Step1Form/Step1Form";
import { Step2Form } from "./components/Step2Form/Step2Form";
import { Step3Form } from "./components/Step3Form/Step3Form";
import { StepMObywatel } from "./components/StepMObywatel/StepMObywatel";
import { Provider } from "./contexts/FormContext";
import { IStep1FormInput } from "./types/IStep1FormInput";
import { IStep2FormInput } from "./types/IStep2FormInput";
import { FinalForm } from "./components/FinalForm/FinalForm";
import { Step0Form } from "./components/Step0Form/Step0Form";
import { BrowserRouter } from "react-router-dom";
import { ILeadsData } from "./types/ILeadsData";
import { Contact } from "./components/Contact/Contact";
import useWindowDimensions from "./hooks/useWindowDimensions";
import logo from "./assets/logo.png";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Expired } from "./components/Expired/Expired";
import { ErrorPage } from "./components/ErrorPage/ErrorPage";
import { StepPPP } from "./components/StepPPP/StepPPP";
import { StepPPPHighRisk } from "./components/StepPPP/StepPPPHighRisk";
import { SurveyListType } from "./types/SurveyListType";
import "dayjs/locale/pl";
//import "./css/bootstrap.min.css";
//import "./css/font-awesome.min.css";

const theme = createTheme({
  typography: {
    fontFamily: ["Arial"].join(","),
  },
});

const App = () => {
  const [leads, setLeads] = useState<ILeadsData>();
  const [step, setStep] = useState<number>(0);
  const [step1, setStep1] = useState<IStep1FormInput>();
  const [step2, setStep2] = useState<IStep2FormInput>();
  const [ppp, setPPP] = useState<SurveyListType>();
  const [number, setNumber] = useState<string>("");
  const [mObywatelGuid, setMObywatelGuid] = useState<string>("");
  const [isMObywatelDone, setIsMObywatelDone] = useState<boolean>(false);
  const { height, width } = useWindowDimensions();

  const renderStep = () => {
    switch (step) {
      case -2:
        return <ErrorPage />;
      case -1:
        return <Expired />;
      case 0:
        return <Step0Form step={step} setStep={setStep} />;
      case 1:
      case 2:
        return <Step1Form step={step} setStep={setStep} />;
      case 3:
        return <Step2Form setStep={setStep} />;
      case 4:
      case 5:
        return <Step3Form setStep={setStep} />;
      case 6:
        return <FinalForm setStep={setStep} />;
      case 7:
        return <StepPPP setStep={setStep} />;
      case 8:
        return <StepPPPHighRisk setStep={setStep} />;
      case 9:
        return <StepMObywatel setStep={setStep} mObywatelGuid={mObywatelGuid} isMObywatelDone={isMObywatelDone} setIsMObywatelDone={setIsMObywatelDone} />;
      default:
        return <Step1Form step={step} setStep={setStep} />;
    }
  };

  return (
    <BrowserRouter>
      <Provider
        value={{
          leads: leads,
          setLeads: setLeads,
          step1: step1,
          setStep1: setStep1,
          step2: step2,
          setStep2: setStep2,
          number: number,
          setNumber: setNumber,
          ppp: ppp,
          setPPP: setPPP,
          mObywatelGuid: mObywatelGuid,
          setMObywatelGuid: setMObywatelGuid
        }}
      >
        <ThemeProvider theme={theme}>
          <nav className="navbar navbar-light bg-light sticky-top">
            <div className="col-12">
              <div className={`${width <= 768 ? "text-center" : "row"}`}>
                <div className={`col-md-3 ${width <= 768 ? "d-none" : ""}`}>
                  <img src={logo} width="155" alt="" />
                </div>
                <div
                  className={`${width <= 992
                    ? "col-md-9 col-offset-9"
                    : "col-md-9 col-offset-9"
                    }`}
                >
                  <p
                    className={`header bold ${width <= 768 ? "smallNavText" : "navText"
                      }`}
                  >
                    Zawarcie umowy zdalnego dostępu{" "}
                    <span
                      style={{
                        fontWeight: 700,
                        color: "#EC6547",
                        position: "fixed",
                        marginLeft: 10,
                      }}
                    >
                      {import.meta.env.VITE_REACT_ENVIRONMENT ?? ""}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </nav>
          <div className="px-1 px-md-4 mx-auto">
            <div className="d-flex justify-content-center">
              <div className="col-12 col-md-12 col-lg-12 col-xl-12">
                <div className="row">
                  <div
                    className={`marginTop col-md-3 text-right ${width <= 768 ? "d-none" : ""
                      }`}
                  >
                    <div
                      className="position-fixed lineSteps"
                      style={{ width: width / 4 }}
                    >
                      <CircleSteps step={step} isMObywatelDone={isMObywatelDone} />
                    </div>
                  </div>

                  <div
                    className={`marginTop ${width <= 992
                      ? "col-md-9 col-offset-9"
                      : "col-md-6 col-offset-6"
                      }`}
                  >
                    <div className={`${width <= 768 ? "" : "mainContainer"}`}>
                      {renderStep()}
                    </div>
                  </div>

                  <div className={`col-md-3 ${width <= 992 ? "d-none" : ""}`}>
                    <div className="position-fixed">
                      <Contact active={step >= 0} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ThemeProvider>
      </Provider>
    </BrowserRouter>
  );
};

export { App };
